<div class="page">
  <geo-dashboard
    class="element"
    [attr.token]="token"
    [attr.api-base-url]="apiBaseUrl"
    [attr.movements-api-base-url]="movementsApiBaseUrl"
    [attr.view]="view"
    storage-token-key="access_token"
    logout-redirect-url="/auth/login"
  ></geo-dashboard>
</div>
